/**
 * @desc 删除分箱信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(aono: string | number, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/deleteBoxInfo/${aono}`, {
      method: "POST",

      ...options,
    }),
  );
}
